import LandingPageActions from '../actions/LandingPageCRUDActions';
import Actions from '../actions/actions';
import {
  setBusy, setUnBusy, retrievedAll,
  update, deleteLocalFirst, retrieved,
} from './common/commonReducers';


const initialState = {
  busy: false,
  entities: [],
};


export default function page(state = initialState, action) {
  switch (action.type) {
    case LandingPageActions.busyAction: return setBusy(state);
    case LandingPageActions.retrievedAction: return retrieved(state, action);
    case LandingPageActions.retrievedAllAction: return retrievedAll(state, action);
    case LandingPageActions.updateAction: return update(state, action);
    case LandingPageActions.deleteLocalAction: return deleteLocalFirst(state, action);
    case Actions.RESET: return initialState;
    case Actions.UNBUSY: return setUnBusy(state);
    default: return state;
  }
}
